"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _RuleEditor = _interopRequireDefault(require("../rule-editor/RuleEditor"));

var _utils = require("../rule-editor/utils");

var _RuleEditorPercentage = _interopRequireWildcard(require("./atoms/RuleEditorPercentage"));

var _RuleEditorCurrency = _interopRequireWildcard(require("./atoms/RuleEditorCurrency"));

var _RuleEditorAccount = _interopRequireWildcard(require("./atoms/RuleEditorAccount"));

var _RuleEditorEvent = _interopRequireWildcard(require("./atoms/RuleEditorEvent"));

(0, _utils.registerType)({
  type: "percentage",
  Component: _RuleEditorPercentage.default,
  validator: _RuleEditorPercentage.isValidPercentValue
});
(0, _utils.registerType)({
  type: "currency",
  Component: _RuleEditorCurrency.default,
  validator: _RuleEditorCurrency.isValidCurrencyValue
});
(0, _utils.registerType)({
  type: "account",
  Component: _RuleEditorAccount.default,
  nextAtom: _RuleEditorAccount.getNextAccountAtom,
  subRule: _RuleEditorAccount.getAccountAtomSubRuleId,
  validator: _RuleEditorAccount.isValidAccountValue,
  atomProcessor: _RuleEditorAccount.accountAtomProcessor
});
(0, _utils.registerType)({
  type: "event",
  Component: _RuleEditorEvent.default,
  nextAtom: _RuleEditorEvent.getNextEventAtom,
  subRule: _RuleEditorEvent.getEventAtomSubRuleId,
  validator: _RuleEditorEvent.isValidEventValue,
  atomProcessor: _RuleEditorEvent.eventAtomProcessor
});
var _default = _RuleEditor.default;
exports.default = _default;